import React from "react";
import Topbar from "./Topbar";
import Footer from "../Footer";
import { Stack } from "@mui/material";
import { graphql, useStaticQuery } from "gatsby";
import PopupBanner from "./PopupBanner";
import { useMount } from "react-use";
import { isEmpty } from "lodash";
import { trackPageLoad } from "../../helpers/analytics";

const BaseLayout = ({ children, location, page }) => {
  const data = useStaticQuery(graphql`
    query BaseSiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      infographicPages: allPrismicInfographic(
        filter: { uid: { nin: "infographic.internal" } }
        sort: { first_publication_date: DESC }
      ) {
        edges {
          node {
            uid
          }
        }
      }
    }
  `);

  useMount(() => {
    if (!isEmpty(page)) {
      trackPageLoad(page);
    }
  });

  return (
    <Stack>
      <Topbar
        location={location}
        recentReportId={data.infographicPages.edges[0].node.uid.split(".")[1]}
      />

      {children}

      <PopupBanner />

      <Footer />
    </Stack>
  );
};

export default BaseLayout;
